
export enum MeasureToolType  {
  NONE ='NONE',
  DISTANCE = 'DISTANCE',
  AREA = 'AREA',
  CIRCLE = 'CIRCLE',
  PROFILE_DEPTH = 'PROFILE_DEPTH',
  BEARING = 'BEARING'    
}